<template>
  <div class="selection-panel">
    <div v-if="!hideHeader" class="selection-head">
      <h1 class="selection-title">Select Company</h1>
      <p class="selection-hint">Select your company to continue.</p>
    </div>

    <div class="selection-scroll">
      <div v-for="group in availableGroups" :key="group.grcpId" class="selection-group">
        <button
          v-b-toggle="'select-group-' + group.grcpId"
          type="button"
          class="selection-group__toggle"
          :class="{ 'is-active': selected.group && selected.group.grcpId === group.grcpId }"
          @click="onGroupSelected(group)"
        >
          {{ group.grcpName }}
        </button>

        <b-collapse
          :id="'select-group-' + group.grcpId"
          accordion="select-group-company-accordion"
          role="tabpanel"
        >
          <div class="selection-group__body">
            <button
              v-for="company in group.availableCompanies"
              :key="company.compId"
              type="button"
              class="selection-option"
              :class="{ 'is-active': selected.company && selected.company.compId === company.compId }"
              @click="onCompanySelected(company)"
            >
              {{ company.compName }}
            </button>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="selection-actions">
      <button
        type="button"
        class="selection-confirm"
        :disabled="!selected.group || !selected.company || isLoading"
        @click="onConfirmSelection"
      >
        <i v-if="isLoading" class="ri-loader-line selection-spinner"></i>
        Confirm
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyActiveSelection',
  props: ['hideHeader', 'disableRedirection'],
  data() {
    return {
      isLoading: false,
      selected: {
        group: undefined,
        company: undefined,
      },
      availableGroups: [],
    };
  },
  async created() {
    const groups = this.$store.getters['auth/availableGroup'];
    const companies = this.$store.getters['auth/availableCompany'];
    this.availableGroups = groups.map((group) => ({
      ...group,
      availableCompanies: Object.values(companies).filter((company) => company.compGrcpId === group.grcpId),
    }));

    const activeCompany = this.$store.state.auth.activeCompany;
    if (activeCompany) {
      this.selected.company = activeCompany;
      this.selected.group = this.availableGroups.find((g) => g.grcpId === activeCompany.compGrcpId);
    }

    // Cuma 1 company yang bisa dipilih - skip picker, auto-confirm. Jangan skip kalau
    // ini dibuka sebagai modal switcher (disableRedirection), biar switcher tetep guna.
    const allCompanies = Object.values(companies);
    if (!this.disableRedirection && allCompanies.length === 1) {
      const onlyCompany = allCompanies[0];
      this.selected.company = onlyCompany;
      this.selected.group = this.availableGroups.find((g) => g.grcpId === onlyCompany.compGrcpId);
      await this.onConfirmSelection();
    }
  },
  methods: {
    async onConfirmSelection() {
      this.isLoading = true;
      try {
        if (this.disableRedirection) {
          await this.$store.dispatch('auth/switchCompany', this.selected.company);
          this.$bvModal.hide('select-company-modal');
        } else {
          await this.$store.dispatch('auth/changeActiveCompany', this.selected);
          this.$router.push({ name: 'AppActiveSelection' });
        }
      } catch (error) {
        console.error('Error confirming company selection:', error?.message);
      } finally {
        this.isLoading = false;
      }
    },
    onCompanySelected(company) {
      this.selected.company = company;
    },
    // Mengembalikan metode ini untuk melacak grup yang dipilih
    onGroupSelected(group) {
      this.selected.group = group;
      // Mengosongkan pilihan company saat grup berbeda dipilih
      if (!this.selected.company || this.selected.company.compGrcpId !== group.grcpId) {
        this.selected.company = undefined;
      }
    },
  },
};
</script>

<style src="@/assets/css/selection-panel.css"></style>
